"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgQuestionMarkOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M12 2c5.523 0 10 4.478 10 10s-4.477 10-10 10S2 17.522 2 12 6.477 2 12 2zm0 18c4.411 0 8-3.589 8-8s-3.589-8-8-8-8 3.589-8 8 3.589 8 8 8z' }),
    react_1.default.createElement("path", { d: 'M9.497 8.952c-.741-.39-.581-1.147-.376-1.442A3.5 3.5 0 0115.5 9.5c0 1.562-1.35 2.579-2.067 3.12l-.021.016c-.571.43-.42 1.381-1.453 1.364-.785-.013-.924-.802-.93-1-.036-1.088 1.033-1.721 1.258-1.867.883-.57 1.213-1.193 1.213-1.633a1.5 1.5 0 00-2.743-.838c-.162.24-.52.68-1.26.29zM11.116 15.866a1.25 1.25 0 111.768 1.768 1.25 1.25 0 01-1.768-1.768z' }))); };
exports.default = SvgQuestionMarkOutline;
//# sourceMappingURL=QuestionMarkOutline.js.map